import { render, staticRenderFns } from "./ModalVideoInvoices.vue?vue&type=template&id=d131b8b6&"
import script from "./ModalVideoInvoices.vue?vue&type=script&lang=js&"
export * from "./ModalVideoInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports